<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper" class="page">
      <div class="container-fluid">
        <b-card>
          <b-form @submit.prevent="addItem" autocomplete="off">
            <div class="mb-4">
              <a href="#" @click.prevent="goBack">
                <i class="fas fa-arrow-left"></i>
                Back to Assets List
                <!-- trở về danh sách tài sản -->
              </a>
              <div class="float-right">
                <button class="btn btn-primary" type="submit">
                  Save
                  <!-- Lưu -->
                </button>
              </div>
            </div>
            <hr />
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        id="select-group-assettypeid"
                        label="Asset Type (*):"
                        label-for="selectAssetTypeId"
                      >
                        <b-form-select
                          id="selectAssetTypeId"
                          v-model="form.assetTypeId"
                          :options="assetTypes"
                          value-field="id"
                          text-field="type"
                          @change="autogenerateAssetCode"
                          required
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col>
                      <b-form-group
                        id="input-group-assetid"
                        label="Asset ID (*):"
                        label-for="inputAssetId"
                      >
                        <b-form-input
                          id="inputAssetId"
                          v-model="form.assetId"
                          required
                          placeholder="Input Asset ID"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-group
                        id="input-group-name"
                        label="Asset Name (*):"
                        label-for="inputName"
                      >
                        <b-form-input
                          id="inputName"
                          v-model="form.assetName"
                          required
                          placeholder="Input Asset Name"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col>
                      <b class="mr-2">Asset Information</b>
                      <!-- <b class="mr-2">Thông tin tài sản</b> -->
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        id="input-group-serial"
                        label="Serial Number:"
                        label-for="inputSerial"
                      >
                        <b-form-input id="inputSerial" v-model="form.serial">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="select-group-departmentid"
                        label="Purchased by (*):"
                        label-for="selectDeparmentId"
                      >
                        <b-form-select
                          id="selectDepartmentId"
                          :options="departments"
                          value-field="id"
                          text-field="tendonvi"
                          v-model="form.departmentId"
                          required
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                        id="select-group-roonid"
                        label="Located at (*):"
                        label-for="selectRoomId"
                      >
                        <b-form-select
                          id="selectRoomId"
                          v-model="form.roomId"
                          :options="rooms"
                          value-field="id"
                          text-field="name"
                          required
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="input-group-detail"
                        label="Description:"
                        label-for="inputDetail"
                      >
                        <b-form-input id="inputDetail" v-model="form.detail">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group
                        id="input-group-job"
                        label="Job:"
                        label-for="inputJob"
                      >
                        <b-form-input id="inputJob" v-model="form.job">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="5" class="mb-4">
                <b-container>
                  <!-- Ngay nhap kho -->
                  <b-row>
                    <b-col cols="6">
                      <b-form-group
                        id="input-group-recievedDate"
                        label="Input Day:"
                        label-for="datepickerRecievedDate"
                      >
                        <vue-datepicker-local
                          v-model="form.wareHouseDate"
                          :local="local"
                          clearable
                          format="DD/MM/YYYY"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        id="input-group-price"
                        label="Price:"
                        label-for="selectPrice"
                      >
                        <my-currency-input v-model="form.price" />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col cols="12" md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col>
                      <b class="mr-2">
                        Asset Status
                        <!-- Tình trạng tài sản -->
                      </b>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <!-- trang thai tai san -->
                    <b-col cols="6">
                      <b-form-group
                        id="select-group-assetstatus"
                        label="Asset Status (*):"
                        label-for="selectAssetStatus"
                      >
                        <b-form-select
                          id="selectAssetStatus"
                          v-model="form.assetStatus"
                          :options="assetStatusses"
                          required
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <!-- trang thai su dung -->
                    <b-col cols="6">
                      <b-form-group
                        id="select-group-usagestatus"
                        label="Status (*):"
                        label-for="selectUsageStatus"
                      >
                        <b-form-select
                          id="selectUsageStatus"
                          v-model="form.status"
                          :options="tinhtrangtaisans"
                          value-field="id"
                          text-field="pickListValue"
                          required
                        >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        id="input-group-purpose"
                        label="Purpose:"
                        label-for="inputPurpose"
                      >
                        <b-form-input id="inputNotation" v-model="form.purpose">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="5" class="mb-4">
                <b-container>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group
                        id="input-group-notation"
                        label="Note:"
                        label-for="inputNotation"
                      >
                        <b-form-input
                          id="inputNotation"
                          v-model="form.notation"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-form-row>
          </b-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import MyCurrencyInput from "../components/App/MyCurrencyInput";

export default {
  name: "Asset",

  components: {
    VueDatepickerLocal,
    MyCurrencyInput,
  },

  data() {
    return {
      asset_search: "",
      form: {
        id: 0,
        assetId: "",
        assetName: "",
        assetTypeId: [],
        employeeId: "",
        employeeFullName: "",
        departmentId: [],
        recievedDate: null,
        assetStatus: [],
        usageStatus: [],
        price: 0,
        notation: "",
        serial: "",
        detail: "",
        job: "",
        purpose: "",
        roomId: 0,
        status: 0,
        wareHouseDate: null,
      },

      assets: [],
      employees: [],
      departments: [],
      assetTypes: [],
      rooms: [],
      roomEnabled: false,
      tinhtrangtaisans: [],
      assetStatusses: ["Tốt", "Hỏng"],
      usageStatusses: ["Đang sử dụng", "Lưu kho"],

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ),
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ),
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"),
      },
    };
  },

  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/employee/getall"),
        axios.get("/api/assettype"),
        axios.get("/api/department"),
        axios.get("api/picklist/tinhtrangtaisan"),
        axios.get("/api/asset"),
        axios.get("/api/room"),
      ])
      .then(
        axios.spread(
          (employee, assettype, department, tinhtrangtaisan, asset, room) => {
            next((vm) =>
              vm.initData(
                employee.data,
                assettype.data.items,
                department.data,
                tinhtrangtaisan.data,
                asset.data,
                room.data,
                to.params
              )
            );
          }
        )
      );
  },

  methods: {
    initData(
      employees,
      assetTypes,
      departments,
      tinhtrangtaisans,
      assets,
      rooms,
      params /*Search query from Asset Menu*/
    ) {
      this.asset_search = params.search;
      this.assetTypes = assetTypes;
      this.employees = employees;
      this.departments = departments;
      this.tinhtrangtaisans = tinhtrangtaisans;
      this.assets = assets;
      this.rooms = rooms;

      //const null_value = {
      //    id: null,
      //    hovaten: "",
      //};

      //employees.unshift(null_value);
    },

    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        name: "asset",
        params: { q: this.asset_search },
      });
    },

    resetForm() {
      this.form.assetName = "";
      this.form.assetId = "";
      this.form.assetTypeId = "";
      this.form.assetStatus = "";
      this.form.usageStatus = "";
      this.form.price = "";
      this.form.notation = "";
    },

    addItem() {
      axios
        .post("/api/asset", {
          assetId: this.form.assetId,
          name: this.form.assetName,
          assetTypeId: this.form.assetTypeId,
          departmentId: this.form.departmentId,
          recievedDate: this.form.recievedDate,
          assetStatus: this.form.assetStatus,
          price: "" + this.form.price,
          notation: this.form.notation,
          Serial: this.form.serial,
          Detail: this.form.detail,
          Job: this.form.job,
          Purpose: this.form.purpose,
          RoomId: this.form.roomId,
          Status: this.form.status,
          wareHouseDate: this.form.wareHouseDate,
        })
        .then((res) => {
          this.$router.push("/asset", () => {
            this.$toast.success("Thêm tài sản thành công !", "Thành công", {
              timeout: 2000,
            });
          });
          this.$router.push(`/edit_asset/${this.form.assetId}`);
        })
        .catch((err) => {
          this.$toast.error(" " + err, "Lỗi", { timeout: 3000 });
        });
    },

    unlockRoom() {
      axios.get(`/api/Room/${this.form.departmentId}`).then((res) => {
        this.rooms = res.data;
        this.roomEnabled = true;
      });
    },

    findAssetType(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });

      return temp.code;
    },

    autogenerateAssetCode() {
      const def_assettype_code = this.findAssetType(
        this.assetTypes,
        this.form.assetTypeId
      );

      var last = "";

      for (var as of this.assets) {
        var assettype_number = as.assetId.slice(-4);
        var assettype_code = as.assetId.replace(assettype_number, "");
        if (def_assettype_code == assettype_code) last = assettype_number;
      }

      if (last == "") last = "0001";
      else if (last != "") {
        last = parseInt(last) + 1;
        if (last % 10 == last) {
          last = "000" + last;
        } else if (last % 100 == last) {
          last = "00" + last;
        } else if (last % 1000 == last) {
          last = "0" + last;
        }
      }

      this.form.assetId = def_assettype_code + last;
    },
  },
};
</script>
